import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import NavigationHeader from './components/NavigationHeader';
import AIHero from './components/AIHero';
import HowItWorks from './components/HowItWorks';
import WhyAIPoweredAgents from './components/WhyAIPoweredAgents';
import FeaturedProperties from './components/FeaturedProperties';
import SellerTools from './components/SellerTools';
import AIEthicsSection from './components/AIEthicsSection';
import AdvancedSearchShowcase from './components/AdvancedSearchShowcase';
import QuickPreferenceSurvey from './components/QuickPreferenceSurvey';
import FooterWithPolicies from './components/FooterWithPolicies';
import MapShowcaseSimple from './components/MapShowcaseSimple';
import RollingIntentBar from './components/RollingIntentBar';
import { useWhiteLabelBranding } from '../../hooks/useWhiteLabelBranding';
import './styles/chat-realestate.css';

const HomePage: React.FC = () => {
  const [userPreferences, setUserPreferences] = useState<any>(null);
  const { isWhiteLabel, tenant, branding } = useWhiteLabelBranding();

  useEffect(() => {
    // Check if user has preferences stored
    const storedPrefs = localStorage.getItem('chatRealEstatePreferences');
    if (storedPrefs) {
      setUserPreferences(JSON.parse(storedPrefs));
    }
  }, []);

  const handlePreferenceComplete = (preferences: any) => {
    setUserPreferences(preferences);
    console.log('User preferences:', preferences);
    
    // You can now use these preferences to:
    // 1. Update the featured properties query
    // 2. Personalize the search suggestions
    // 3. Track user intent for analytics
  };

  const handlePreferenceSkip = () => {
    console.log('User skipped preference survey');
  };

  return (
    <div className="chat-realestate-home">
      {/* Quick Preference Survey for First-Time Visitors */}
      <QuickPreferenceSurvey 
        onComplete={handlePreferenceComplete}
        onSkip={handlePreferenceSkip}
      />

      {/* Enhanced Navigation Header */}
      <NavigationHeader tenant={tenant} branding={branding} isWhiteLabel={isWhiteLabel} />

      {/* AI-Powered Hero Section */}
      <AIHero tenant={tenant} branding={branding} isWhiteLabel={isWhiteLabel} />

      {/* How It Works */}
      <section className="how-it-works">
        <Container>
          <HowItWorks />
        </Container>
      </section>

      {/* Why AI-Powered Agents */}
      <WhyAIPoweredAgents />

      {/* Seller Tools — Moved UP from position #9 so sellers see it before bouncing */}
      <section className="seller-tools">
        <Container>
          <SellerTools />
        </Container>
      </section>

      {/* NEW: AI-Powered Location Showcase */}
      <MapShowcaseSimple />

      {/* Featured Properties */}
      <section className="featured-properties">
        <Container>
          <FeaturedProperties userPreferences={userPreferences} />
        </Container>
      </section>

      {/* AI Ethics and Fair Housing */}
      <AIEthicsSection />

      {/* Advanced Search Showcase */}
      <AdvancedSearchShowcase />

      {/* Enhanced Footer with Policies */}
      <FooterWithPolicies tenant={tenant} branding={branding} isWhiteLabel={isWhiteLabel} />
      
      {/* Rolling Intent Bar - Sticky Bottom */}
      <RollingIntentBar />
      
    </div>
  );
};

export default HomePage;